import React from 'react';

function ChevronDown(props: object) {
  return (
    <svg
      width="13"
      height="8"
      viewBox="0 0 13 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.5 7.70005L0.5 1.70005L1.9 0.300049L6.5 4.90005L11.1 0.300049L12.5 1.70005L6.5 7.70005Z"
        fill="currentColor"
      />
      <path
        d="M6.5 7.70005L0.5 1.70005L1.9 0.300049L6.5 4.90005L11.1 0.300049L12.5 1.70005L6.5 7.70005Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default ChevronDown;
